import hasher from './hasher';

export default {
  methods: {
    encodeHash() {
      if (!this.id) {
        throw new Error('Can\'t get hash key');
      }
      return hasher.encode(this.id);
    },
    decodeHash(hash) {
      return hasher.decode(hash);
    },
    makeToast(options) {
      const defaultOptions = {
        title: '警告！',
        variant: 'danger',
        toaster: 'b-toaster-bottom-right',
        solid: true,
        noAutoHide: true,
        appendToast: true,
      };
      const mergerdOptions = { ...defaultOptions, ...options };

      this.$bvToast.toast(mergerdOptions.content, {
        title: mergerdOptions.title,
        variant: mergerdOptions.variant,
        toaster: mergerdOptions.toaster,
        solid: mergerdOptions.solid,
        noAutoHide: mergerdOptions.noAutoHide,
        appendToast: mergerdOptions.appendToast,
      });
    },
  },
};
